import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import MetaTags from 'react-meta-tags';
import SweetAlert from 'react-bootstrap-sweetalert';

import 'react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory from 'react-bootstrap-table2-editor';
import filterFactory from 'react-bootstrap-table2-filter';
import InputMask from 'react-input-mask';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import BtnLoader from '../../components/Loaders/btnLoader';
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  Button,
  ModalHeader,
  ModalBody,
  FormGroup,
  Label,
  Alert,
  Input
} from 'reactstrap';
import paginationFactory, { PaginationProvider } from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import {
  getCustomerService,
  addCustomerService,
  updateCustomerService,
  deleteCustomerService,
} from '../../store/customerService/actions';
import PageLoader from '../../components/Loaders/pageLoader';
//Import Breadcrumb
import Breadcrumbs from '../../components/Breadcrumb';
import { getScreenHeight } from '../../helpers/screen_height_helper';
import { Notification } from '../../components/Notifications/notifications';

class CustomerServiceList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      custServ: [],
      my_custService: [],
      correctDate: true,
      modalNewIssue: false,
      isEdit: false,
      displayResolved: false,
      alert: null,
      error: '',
      date: '',
      CustomerServiceListColumns: [
        {
          text: 'ID',
          dataField: '_id',
          sort: true,
          editable: false,
          formatter: (cell, row, rowIndex) => rowIndex + 1
        },
        {
          text: 'Date',
          dataField: 'date',
          sort: true,
          hidden: false,
          csvFormatter: (cell, row, rowIndex) =>
            row.date != null && new Date(row.date).toLocaleDateString('en-GB'),
          formatter: (cellContent, custService) => (
            <h5 className='font-size-16 mb-1'>
              {custService.date != null && new Date(custService.date).toLocaleDateString('en-GB')}
            </h5>
          )
        },
        {
          text: 'Manager',
          dataField: 'manager',
          sort: true,
          editable: false,
          formatter: (cellContent, custService) => (
            <div className='slname-width'>
              <h5 className='font-size-16 mb-1'>
                {custService.manager ? (
                <span>
                  <div>
                    {!custService.manager.profilePic ? (
                    <div className='avatar-sm m-2 d-inline-block'>
                      <span className='avatar-title rounded-circle'>
                        {custService.manager.fname.charAt(0)}
                      </span>
                    </div>
                    ) : (<img className='rounded-circle avatar-sm m-2' src={custService.manager.profilePic} alt='profile pic'/>)}
                    <span>
                      {custService.manager.fname} {custService.manager.sname}
                    </span>
                  </div>
                </span>
                ) : null}
              </h5>
              {/* <h5 className='font-size-16 mb-1'>
                {custService.manager ? (
                  <span>
                  {custService.manager.fname}
                  &nbsp;
                  {custService.manager.sname}
                </span>
                ) : null}
              </h5> */}
            </div>
          )
        },
        {
          text: 'Client Name',
          dataField: 'clientName',
          sort: true,
          hidden: false,
          editable: false,
          formatter: (cellContent, custService) => (
            <div>
              <h5 className='font-size-16 mb-1'>{custService.clientName}</h5>
            </div>
          )
        },
        {
          text: 'Forwarder',
          dataField: 'forwarder',
          sort: true,
          hidden: false,
          editable: false,
          formatter: (cellContent, custService) => (
            <div className='name-width'>
              <h5 className='font-size-16 mb-1'>{custService.forwarder}</h5>
            </div>
          )
        },
        {
          text: 'Tracking',
          dataField: 'tracking',
          sort: true,
          hidden: false,
          editable: false,
          formatter: (cellContent, custService) => (
            <div className='name-width'>
              <a href={custService.tracking} target='_blank' rel="noreferrer">
                {custService.tracking}
              </a>
            </div>
          )
        },
        {
          text: 'Description',
          dataField: 'description',
          sort: true,
          editable: false,
          formatter: (cellContent, custService) => (
            <div className='name-width'>
              <h4 className='mb-0'>{custService.description}</h4>
            </div>
          )
        },
        {
          text: 'Respond',
          dataField: 'respond',
          sort: true,
          csvExport: false,
          hidden: false,
          editable: true,
          formatter: (cellContent, custService) => (
            <div className='name-width'>
              <h4 className='font-size-16 mb-1'>{custService.respond}</h4>
            </div>
          )
        },
        {
          text: 'Responsible',
          dataField: 'orderTaker',
          sort: true,
          csvExport: false,
          hidden: false,
          editable: false,
          formatter: (cellContent, custService) => (
            <div>
              <h4 className='font-size-16 mb-1'>{custService.orderTaker && (custService.orderTaker.fname +' '+ custService.orderTaker.sname) }</h4>
            </div>
          )
        },
        {
          text: 'Status',
          dataField: 'status',
          sort: true,
          editable: false,
          formatter: (cellContent, custService) => (
            // <div className="name-width">
            //   <h4 className="font-size-16 mb-1">{custService.status}</h4>
            // </div>

            <div className='form-group'>
              <select
                className='form-control wh-manager-selection'
                value={custService.status || ''}
                name='status'
                onChange={(e) => this.handleEditIssueClick(e, 'selected', custService)}
              >
                <option value='inProgress' className='alert-primary'>
                  In progress
                </option>
                <option value='done' className='alert-primary'>
                  Done
                </option>
              </select>
            </div>
          )
        },
        {
          dataField: 'menu',
          //   isDummyField: true,
          text: 'Action',
          editable: false,
          formatter: (cellContent, custService) => (
            <div className='d-flex gap-3'>
              {(this.props.profileData.permissions.includes('customerServiceRspFldAccess') && custService.orderTaker !== null) ? (
                <Link className='text-info' to='#'>
                  <i
                    className='mdi mdi-clipboard-check  font-size-18'
                    id='deletetooltip'
                    onClick={() => this.handleTakeOrder(custService)}
                  ></i>
                </Link>
              ) : (
                <Link className='text-warning' to='#'>
                  <i
                    className='mdi mdi-clipboard-alert  font-size-18'
                    id='deletetooltip'
                    onClick={() => this.handleTakeOrder(custService)}
                  ></i>
                </Link>
              )}
              {/* {custService.orderTaker == '' && (
                <Link className='text-warning' to='#'>
                  <i
                    className='mdi mdi-clipboard-alert  font-size-18'
                    id='deletetooltip'
                    onClick={() => this.handleTakeOrder(custService)}
                  ></i>
                </Link>
              )} */}
              {custService.manager._id === this.props.profileData._id && (
                <>
                  <Link className='text-success' to='#'>
                    <i
                      className='mdi mdi-pencil font-size-18'
                      id='edittooltip'
                      onClick={(e) => this.handleEditIssueClick(e, 'not selected', custService)}
                    ></i>
                  </Link>
                  <Link className='text-danger' to='#'>
                    <i
                      className='mdi mdi-delete font-size-18'
                      id='deletetooltip'
                      onClick={() => this.handleDeleteIssue(custService)}
                    ></i>
                  </Link>
                </>
              )}
            </div>
          )
        }
      ]
    };
    // this.getScreenHeight = this.getScreenHeight.bind(this);
    this.handleNewIssueClick = this.handleNewIssueClick.bind(this);
    this.toggleNewIssueModal = this.toggleNewIssueModal.bind(this);
    this.handleNewIssueSubmit = this.handleNewIssueSubmit.bind(this);

    this.handleTakeOrder = this.handleTakeOrder.bind(this);
    this.handleEditIssueClick = this.handleEditIssueClick.bind(this);
    this.handleDeleteIssue = this.handleDeleteIssue.bind(this);

    this.afterSaveCell = this.afterSaveCell.bind(this);
    this.onChange = this.onChange.bind(this);
    this.toggleResolvedIssues = this.toggleResolvedIssues.bind(this);
    this.hiddenRowKeys = this.hiddenRowKeys.bind(this);
    this.filterMyOrders = this.filterMyOrders.bind(this);
    this.indication = this.indication.bind(this);
  }
  componentDidMount() {
    const { onGetCustomerService } = this.props;
    onGetCustomerService();
    window.addEventListener('load', this.getScreenHeight);
    window.addEventListener('click', this.getScreenHeight, { once: true });
    window.addEventListener('resize', this.getScreenHeight);
  }
  componentWillUnmount() {
    window.removeEventListener('load', this.getScreenHeight);
    window.removeEventListener('click', this.getScreenHeight);
    window.removeEventListener('resize', this.getScreenHeight);
  }
  /**
   * get screen height to set it for table
   */
  // getScreenHeight = (click) => {
  //   if(document.getElementById("card-section")){ 
  //     let screenHeight = document.getElementById('card-section').offsetHeight;
  //     document
  //       .querySelector('.react-bootstrap-table')
  //       .setAttribute('style', 'height: calc(' + screenHeight + 'px - 70px); overflow: auto;');
  //   }
  // };
  /**
   * Empty issues array and set edit to false. Open new order modal
   */
  handleNewIssueClick = () => {
    this.setState({ custServ: [], error: '', isEdit: false, date: '' });
    this.toggleNewIssueModal();
  };
  /**
   * Close/Open new modal
   */
  toggleNewIssueModal = () => {
    this.setState((prevState) => ({ modalNewIssue: !prevState.modalNewIssue }));
  };
  /**
   * Hide/Show issues
   */
  toggleResolvedIssues = () => {
    this.setState((prevState) => ({
      displayResolved: !prevState.displayResolved
    }));
  };

  /**
   * Function to assign values of selected issue
   * @param {array} arg
   */
  handleEditIssueClick = (e, type, custService) => {
    const { onUpdateCustomerService, profileData } = this.props;
    this.setState({
      custServ: {
        _id: custService._id,
        manager: custService.manager,
        forwarder: custService.forwarder,
        tracking: custService.tracking,
        respond: custService.respond,
        description: custService.description,
        clientName: custService.clientName,
        orderTaker: custService.orderTaker,
        status: custService.status
      },
      isEdit: true,
      error: '',
      date: new Date(custService.date).toLocaleDateString('en-GB')
    });
    if (type === 'selected') {
      const name = e.target.name;
      custService[name] = e.target.value;
      const updatedProgress = {
        _id: custService._id,
        [name]: e.target.value,
        orderTaker: profileData._id
      }
      onUpdateCustomerService(updatedProgress);
    }
    if (type === 'not selected') {
      this.toggleNewIssueModal();
    }
  };
  /**
   * Take issue
   * @param {*} custService 
   */
  handleTakeOrder = (custService) => {
    const getAlert = () => (
      <SweetAlert
        success
        showCancel
        confirmBtnText='Yes, I take it!'
        confirmBtnBsStyle='success'
        title='Are you sure you want to take?'
        onConfirm={() => this.updateTaker(custService)}
        onCancel={this.hideAlert}
        focusCancelBtn
      ></SweetAlert>
    );

    this.setState({
      alert: getAlert()
    });
  };
  /**
   * Update who is responsible for the order
   * @param {*} custService 
   */
  updateTaker = (custService) => {
    const { onUpdateCustomerService } = this.props;
    const updateCustomerService = {
      _id: custService._id,
      orderTaker: this.props.profileData._id
    };
    onUpdateCustomerService(updateCustomerService);
    this.hideAlert();
  };
  /**
   * Function to submit new order or edit current order
   * @param {*} e
   * @param {array} values
   */
  handleNewIssueSubmit = (e, values) => {
    const { onAddNewCustomerService, onUpdateCustomerService, managers } = this.props;
    const { isEdit, custServ, date } = this.state;
    if (isEdit) {
      const updateCustomerService = {
        _id: custServ._id,
        date: date.split('/').reverse().join('-'),
        manager: values.manager,
        forwarder: values.forwarder,
        tracking: values.tracking,
        clientName: values.clientName,
        description: values.description,
        respond: values.respond,
        orderTaker: values.orderTaker,
        status: values.status
      };
      // updated order
      onUpdateCustomerService(updateCustomerService);
    } else {
      const newCustomerService = {
        date: date.split('/').reverse().join('-'),
        manager: values['manager'],
        forwarder: values['forwarder'],
        tracking: values['tracking'],
        clientName: values['clientName'],
        description: values['description'],
        respond: '',
        status: '',
        orderTaker: '',
        fname: '',
        sname: '',
        module: 'Bot Battlefield Notification',
        option: 'newCustomerService'
      };
      managers.map((id) => {
        if (id._id === values['manager']) {
          newCustomerService['fname'] = id.fname;
          newCustomerService['sname'] = id.sname;
        }
        return newCustomerService;
      });
      // save new order to battlefield
      onAddNewCustomerService(newCustomerService);
    }
    this.setState({ error: '', isEdit: false });
    this.toggleNewIssueModal();
  };
  hideAlert = () => this.setState({ alert: null });
  /**
   * Function to delete order from the table
   * @param {array} battle
   */
  handleDeleteIssue = (custServ) => {
    const getAlert = () => (
      <SweetAlert
        danger
        showCancel
        confirmBtnText='Yes, delete it!'
        confirmBtnBsStyle='danger'
        title='Are you sure?'
        onConfirm={() => this.deleteAlert(custServ)}
        onCancel={this.hideAlert}
        focusCancelBtn
      ></SweetAlert>
    );

    this.setState({
      alert: getAlert()
    });
  };
  /**
   * Display alert for deleting an issue
   * @param {*} issue selected issue
   */
  deleteAlert = (custServ) => {
    const { onDeleteCustomerService } = this.props;
    onDeleteCustomerService(custServ);
    this.hideAlert();
  };
  /**
   * Hide/Display taken issues 
   * @returns array of issues
   */
  hiddenRowKeys = () => {
    let hiddenArr = [];
    this.props.custService.map((custService, index) => {
      if (custService.status === 'done' && this.state.displayResolved === false) {
        hiddenArr.push(custService._id);
      } else if (custService.status === '' && this.state.displayResolved === true) {
        hiddenArr.push(custService._id);
      }
    });
    return hiddenArr;
  };
  /**
   * check if the date is correct
   * @param {*} event value from input
   */
  onChange = (event) => {
    if (parseFloat(event.target.value.substring(3, 5)) > 12) {
      this.setState({ correctDate: false });
    } else {
      this.setState({
        correctDate: true,
        [event.target.name]: event.target.value
      });
    }
  };
  /**
   * Function to display orders only related to login person
   * @param {*} e
   */
  filterMyOrders = (e) => {
    const { custService, profileData } = this.props;
    let my_custService = [];
    if (e.target.checked === true) {
      custService.map((cust) => {
        if (cust.manager._id === profileData._id) {
          my_custService.push(cust);
        }
        return my_custService;
      });
      if (my_custService.length === 0) {
        my_custService.push({ manager: 'No Results Found' });
      }
      this.setState({ my_custService: my_custService });
    } else {
      this.setState({ my_custService: [] });
    }
  };
  /**
   * Display empty table
   * @returns
   */
  indication = () => {
    let emptyMessage = '';
    if (
      this.state.my_custService.length !== 0 &&
      this.state.my_custService[0]['manager'] === 'No Results Found'
    ) {
      emptyMessage = `No Results Found`;
    }
    return emptyMessage;
  };
  /**
   *
   * @param {String} oldValue
   * @param {String} newValue
   * @param {Arr} row
   * @param {String} column
   * @param {String} rowId
   * @returns saving data after editing is finsihed
   */
  afterSaveCell = (oldValue, newValue, row, column, rowId) => {
    const { onUpdateCustomerService } = this.props;
    setTimeout(() => {
      row[column.dataField] = newValue;
      const updatedRespond = {
        _id: row._id,
        respond: row.respond
      };
      onUpdateCustomerService(updatedRespond);

      // if (newValue !== oldValue) {
      const result = this.state.CustomerServiceListColumns.map((row_map) => {
        if (row_map.id === rowId) {
          const newRow = { ...row_map };
          newRow[column.dataField] = newValue;
          return newRow;
        }
        return row_map;
      });
      this.setState({ CustomerServiceListColumns: result });
      // }
    }, 100);
    return { newValue, async: true };
  };

  render() {
    const { SearchBar } = Search;
    const { profileData, custService, managers, loading } = this.props;
    const { isEdit, custServ, my_custService, error, date, alert, correctDate } = this.state;
    const pageOptions = {
      sizePerPage:
        my_custService.length !== 0 && my_custService[0]['manager'] === 'No Results Found'
          ? 0
          : my_custService.length !== 0
          ? my_custService.length
          : custService.length,
      sizePerPageList: [500, 1000, 1500],
      totalSize:
        my_custService.length !== 0 && my_custService[0]['manager'] === 'No Results Found'
          ? 0
          : my_custService.length !== 0
          ? my_custService.length
          : custService.length,
      custom: true
    };
    const defaultSorted = [
      {
        dataField: 'date', // if dataField is not match to any column you defined, it will be ignored.
        order: 'asc' // desc or asc
      }
    ];
    return (
      <React.Fragment>
        {/* {profileData.length === 0 && loading && <PageLoader />} */}
        {profileData.length !== 0 && <PageLoader progress={!loading && {"step": "Completed","time": 100}} isLoading={loading}/>}
        <div className='page-content'>
          <MetaTags>
            <title>Customer Service</title>
          </MetaTags>
          <Container fluid>
          {profileData.permissions.includes('customerServiceAccess') ? (
            <>
              {/* Render Breadcrumbs */}
              <Breadcrumbs title='Korupharma' breadcrumbItem='Customer Service' />
              <Row id='card-section' onLoad={getScreenHeight()}>
                <Col lg='12'>
                  <Card>
                    <CardBody className='cardBodySticky'>
                      <PaginationProvider
                          pagination={paginationFactory(pageOptions)}
                          keyField='_id'
                          columns={this.state.CustomerServiceListColumns}
                          data={
                            my_custService.length !== 0 &&
                            my_custService[0]['manager'] === 'No Results Found'
                              ? []
                              : my_custService.length !== 0
                              ? my_custService
                              : custService
                          }
                        >
                          {({ paginationProps, paginationTableProps }) => (
                            <ToolkitProvider
                              keyField='_id'
                              columns={this.state.CustomerServiceListColumns}
                              data={
                                my_custService.length !== 0 &&
                                my_custService[0]['manager'] === 'No Results Found'
                                  ? []
                                  : my_custService.length !== 0
                                  ? my_custService
                                  : custService
                              }
                              search
                            >
                              {(toolkitprops) => (
                                <React.Fragment>
                                  <Row className='mb-2 me-1'>
                                    <Col md='7' sm='12' className='d-flex'>
                                      <div
                                        className='search-box ms-2 mb-2 me-2 d-inline-block'
                                        id='myinputfield'
                                      >
                                        <div className='position-relative'>
                                          <SearchBar {...toolkitprops.searchProps} />
                                          <i className='bx bx-search-alt search-icon' />
                                        </div>
                                      </div>
                                      <FormGroup className='d-flex ps-0 justify-content-between form-switch form-switch-lg form-group me-2'>
                                        <Label for='myOrders'> My Orders </Label>
                                        <Input
                                          name='myOrders'
                                          onChange={(e) => this.filterMyOrders(e)}
                                          className='ms-4'
                                          id='myOrders'
                                          type='checkbox'
                                          value={false}
                                          // value={column.toggle ? 'true' : 'false'}
                                        />
                                      </FormGroup>
                                      <Notification compData={my_custService.length !== 0 && my_custService[0]['manager'] === 'No Results Found'
                                                   ? [] : my_custService.length !== 0 ? my_custService : custService} keyWord='customer' module='Bot Battlefield Notification' />
                                    </Col>
                                    <Col md='5' sm='12'>
                                      <div className='text-sm-end'>
                                        {this.state.displayResolved ? (
                                          <>
                                            <Button
                                              color='warning'
                                              className='btn-block mb-2 me-5 btn btn-primary'
                                              onClick={this.toggleResolvedIssues}
                                              id='create-order-btn'
                                            >
                                              <i className='bx bx-angry me-1' />
                                              Hide Resolved Issues
                                            </Button>
                                          </>
                                        ) : (
                                          <>
                                            <Button
                                              color='primary'
                                              className='btn-block mb-2 me-5 btn btn-success'
                                              onClick={this.toggleResolvedIssues}
                                              id='create-order-btn'
                                            >
                                              <i className='bx bx-smile me-1' />
                                              Show Resolved Issues
                                            </Button>
                                          </>
                                        )}

                                        <Button
                                          color='primary'
                                          className='btn-block mb-2 me-2 btn btn-primary'
                                          onClick={this.handleNewIssueClick}
                                          id='create-order-btn'
                                        >
                                          <i className='mdi mdi-plus-circle-outline me-1' />
                                          Add Issue
                                        </Button>
                                        <Modal
                                          size='md'
                                          isOpen={this.state.modalNewIssue}
                                          className={this.props.className}
                                          toggle={this.toggleNewIssueModal}
                                        >
                                          <ModalHeader toggle={this.toggleNewIssueModal} tag='h4'>
                                            {!!isEdit ? 'Edit Issue' : 'Add Issue'}
                                          </ModalHeader>
                                          <ModalBody>
                                            {error !== '' && error ? (
                                              <Alert color='danger'>{error} </Alert>
                                            ) : null}
                                            <AvForm onValidSubmit={this.handleNewIssueSubmit}>
                                              <Row>
                                                <Col md={4}>
                                                  <FormGroup className='mb-3'>
                                                    <Label>Date</Label>
                                                    <InputMask
                                                      mask='99/99/9999'
                                                      value={date}
                                                      name='date'
                                                      onChange={this.onChange}
                                                      className={
                                                        correctDate
                                                          ? ' form-control input-mask'
                                                          : 'form-control input-mask is-invalid'
                                                      }
                                                    />
                                                    {!correctDate && (
                                                      <div className='invalid-feedback'>
                                                        Invalid Date. Please use dd/mm/yyyy format
                                                      </div>
                                                    )}
                                                  </FormGroup>
                                                </Col>
                                                <Col md={4}>
                                                  <FormGroup className='mb-3'>
                                                    <AvField
                                                      type='select'
                                                      name='manager'
                                                      className='form-select'
                                                      label='Manager'
                                                      errorMessage='Please select manager'
                                                      validate={{
                                                        required: {
                                                          value: true
                                                        }
                                                      }}
                                                      value={
                                                        custServ.manager
                                                          ? custServ.manager._id
                                                          : profileData._id
                                                      }
                                                    >
                                                      <option>Choose</option>

                                                      {managers.map((manager) => {
                                                        return (
                                                          <option
                                                            key={manager._id}
                                                            value={manager._id}
                                                          >
                                                            {manager.fname} {manager.sname}
                                                          </option>
                                                        );
                                                      })}
                                                    </AvField>
                                                  </FormGroup>
                                                </Col>
                                                <Col md={4}>
                                                  <FormGroup className='mb-3'>
                                                    <AvField
                                                      name='forwarder'
                                                      label='Forwarder'
                                                      autoComplete='off'
                                                      list='urls'
                                                      value={custServ.forwarder || ''}
                                                    />
                                                    <datalist id='urls'>
                                                      <optgroup label='Bank'>
                                                        <option>EMS</option>
                                                        <option>FedEx</option>
                                                        <option>DHL</option>
                                                        <option>Logistics</option>
                                                        <option>Korean Post</option>
                                                      </optgroup>
                                                    </datalist>
                                                  </FormGroup>
                                                </Col>
                                              </Row>
                                              <Row>
                                                <Col md={6}>
                                                  <FormGroup className='mb-3'>
                                                    <AvField
                                                      name='tracking'
                                                      label='Tracking'
                                                      type='url'
                                                      errorMessage='Invalid URL'
                                                      autoComplete='off'
                                                      validate={{
                                                        required: {
                                                          value: true
                                                        }
                                                      }}
                                                      value={custServ.tracking || ''}
                                                    />
                                                  </FormGroup>
                                                </Col>

                                                <Col md={6}>
                                                  <FormGroup className='mb-3'>
                                                    <AvField
                                                      name='clientName'
                                                      label='Client Name'
                                                      type='text'
                                                      // autoFocus={true}
                                                      autoComplete='off'
                                                      value={
                                                        custServ.clientName
                                                          ? custServ.clientName
                                                          : ''
                                                      }
                                                    />
                                                  </FormGroup>
                                                </Col>
                                              </Row>
                                              <Row>
                                                <Col md={12}>
                                                  <FormGroup className='mb-3'>
                                                    <AvField
                                                      name='description'
                                                      label='Description'
                                                      autoComplete='off'
                                                      type='textarea'
                                                      rows={5}
                                                      value={custServ.description || ''}
                                                    />
                                                  </FormGroup>
                                                </Col>
                                              </Row>
                                              <Row>
                                                <Col>
                                                  <div className='text-end'>
                                                    {loading && <BtnLoader />}
                                                    <button
                                                      // type="submit"
                                                      className='btn btn-success save-user'
                                                      disabled={
                                                        !correctDate ||
                                                        (loading && true)
                                                      }
                                                    >
                                                      {!!isEdit ? 'Edit Issue' : 'Add Issue'}
                                                    </button>
                                                  </div>
                                                </Col>
                                              </Row>
                                            </AvForm>
                                          </ModalBody>
                                        </Modal>
                                      </div>
                                    </Col>
                                  </Row>
                                  <Row id='table-section'>
                                    <BootstrapTable
                                      {...toolkitprops.baseProps}
                                      {...paginationTableProps}
                                      defaultSorted={defaultSorted}
                                      classes={'table align-middle table-nowrap'}
                                      headerClasses='header-class is-sticky-hdr'
                                      id='tableScroll'
                                      filter={filterFactory()}
                                      noDataIndication={this.indication}
                                      responsive
                                      hiddenRows={this.hiddenRowKeys()}
                                      cellEdit={cellEditFactory({
                                        mode: 'click',
                                        blurToSave: true,
                                        afterSaveCell: this.afterSaveCell
                                      })}
                                    />
                                  </Row>
                                  {alert}
                                </React.Fragment>
                                
                              )}
                            </ToolkitProvider>
                          )}
                      </PaginationProvider>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </>
          ) : (
            <Alert color='danger'> You do not have access to this page. </Alert>
          )}
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

CustomerServiceList.propTypes = {
  custService: PropTypes.array,
  onGetCustomerService: PropTypes.func,
  onAddNewCustomerService: PropTypes.func,
  onUpdateCustomerService: PropTypes.func,
  onDeleteCustomerService: PropTypes.func,
};
  
const mapStateToProps = ({ customerService }) => ({
  custService: customerService.custService,
  managers: customerService.managers,
  loading: customerService.loading
});

const mapDispatchToProps = (dispatch) => ({
  onGetCustomerService: () => dispatch(getCustomerService()),
  onAddNewCustomerService: (custService) => dispatch(addCustomerService(custService)),
  onUpdateCustomerService: (custService) => dispatch(updateCustomerService(custService)),
  onDeleteCustomerService: (custService) => dispatch(deleteCustomerService(custService)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CustomerServiceList));